import breadcrumbDictionary from "./breadcrumbDictionary";
import roleDictionary from "./roleDictionary";
import roleToUrl from "./roleToUrl";

const dictionary = {
  breadcrumbDictionary,
  roleDictionary,
  roleToUrl,
};
export default dictionary;
